import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSuperbar = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <rect width={32} height={32} fill="#0A0A0A" rx={3.86207} />
    <path
      fill="#fff"
      d="M20.7809 7.29004H17.6945C17.5654 7.29004 17.4403 7.33526 17.341 7.41779L10.995 12.696C10.8688 12.801 10.7958 12.9567 10.7958 13.1209V15.9422C10.7958 16.2475 11.0432 16.4949 11.3484 16.4949H13.828C14.6226 16.4949 14.9819 17.4887 14.371 17.9969L10.8661 20.912C10.7398 21.017 10.6668 21.1727 10.6668 21.3369V24.1582C10.6668 24.4635 10.9143 24.7109 11.2195 24.7109H14.2511C14.3802 24.7109 14.5053 24.6657 14.6045 24.5831L21.0053 19.2594C21.1315 19.1544 21.2046 18.9987 21.2046 18.8345V16.0587C21.2046 15.7535 20.9571 15.5061 20.6519 15.5061H18.1175C17.323 15.5061 16.9636 14.5123 17.5745 14.0042L21.1342 11.0434C21.2604 10.9384 21.3335 10.7827 21.3335 10.6185V7.84275C21.3335 7.53753 21.086 7.29009 20.7808 7.29009L20.7809 7.29004Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSuperbar);
const Memo = memo(ForwardRef);
export default Memo;
